import { render, staticRenderFns } from "./EmployeeComponent.vue?vue&type=template&id=0503e6ae&scoped=true"
import script from "./EmployeeComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeComponent.vue?vue&type=script&lang=js"
import style0 from "./EmployeeComponent.vue?vue&type=style&index=0&id=0503e6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503e6ae",
  null
  
)

export default component.exports